export enum sourceTypeEnum {
  /** 1-oa */
  oa = 1,
  /** PMC供应商 */
  pmc_supplier = 2,
  /** pmc工厂 */
  pmc_factory = 3,
}
